import { getBadgeModel } from '~/router/navigation/badges';
import { resolveRouteLink } from '~/router/navigation/links';
import { getProgressModel } from '~/router/navigation/progress';
import { filterRoutesForSections } from '~/router/navigation/sections';
import { ROUTES_BADGES } from '~/router/routes';

import type { RouteObject } from 'react-router-dom';
import type { NavItemModel } from '~/router/navigation/types';
import type { ROUTES_SECTIONS } from '~/router/routes';
import type { NavigationContext } from '~/store/selectors/navigationSelectors';

interface BuildNavItemsParams {
  routes: RouteObject[];
  sections: ROUTES_SECTIONS[];
  clanId?: string;
  search: string;
}

export const buildNavItems = (params: BuildNavItemsParams, navigationContext: NavigationContext): NavItemModel[] => {
  const { routes, sections, clanId, search } = params;

  const visibleRoutes = filterRoutesForSections({ routes, sections }, navigationContext);

  return visibleRoutes.map((route, index) => {
    const title = route.handle?.title?.(navigationContext) ?? '';

    const to = resolveRouteLink({
      path: route.path ?? '',
      clanId: clanId,
      search: search,
    });

    const badgeModel = getBadgeModel(route.handle?.badge, navigationContext);
    const progressModel = getProgressModel(route, navigationContext);

    const separator = Boolean(route.handle?.separator?.(navigationContext));

    const isAttention =
      route.handle?.badge === ROUTES_BADGES.TASKS &&
      navigationContext.clanTasksUnclaimedAmount > 0 &&
      navigationContext.canClaimRewards;

    return {
      key: route.path ?? String(index),
      to,
      end: route.handle?.end ?? false,
      replace: route.handle?.replace ?? navigationContext.isClanHubEnabled,
      badge: route.handle?.badge,
      sections: route.handle?.sections,

      title,
      badgeModel,
      progressModel,

      flags: {
        separator,
        isAttention,
      },

      route,
    };
  });
};
